"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _styling = require("../../../../toolkit/styling");

var _providers = require("../../../../toolkit/providers");

var _BasicColumn = _interopRequireDefault(require("./BasicColumn"));

//
//  src/data/table/CodeColumn.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 12/14/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */

/* Relative Imports */
var CodeColumn = function CodeColumn(props) {
  var styles = useStylesheet(props);
  return /*#__PURE__*/_react["default"].createElement(_BasicColumn["default"], props, function (_ref) {
    var row = _ref.row,
        value = _ref.value;
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: (0, _styling.css)(styles.root)
    }, value);
  });
};

var _default = CodeColumn;
exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  var _useTheme = (0, _providers.useTheme)(),
      surfaceLight = _useTheme.surfaceLight;

  return (0, _react.useMemo)(function () {
    return (
      /* eslint-disable local-rules/unwrapped-i18n */
      _aphrodite.StyleSheet.create({
        root: {
          fontFamily: "'Source Code Pro', monospace",
          padding: "5px 10px",
          borderRadius: 3,
          backgroundColor: surfaceLight,
          whiteSpace: "normal"
        }
      })
    );
  }, [surfaceLight]);
};